import localeDataset from '@wix/locale-dataset-javascript';

import { useTranslation } from '../contexts/translation-context';
import { useCountryCode } from '../fields/multiline-address/multiline-address/country-code-context';

export type AddressPart =
  | 'country'
  | 'subdivision'
  | 'addressLine1'
  | 'addressLine2'
  | 'city'
  | 'zipCode'
  | 'streetName'
  | 'streetNumber'
  | 'phone'
  | 'company';

export function useAddressLabel(addressPart: AddressPart) {
  const { t } = useTranslation();
  const countryCode = useCountryCode();
  const country =
    countryCode && localeDataset.getCountryByShortKey(countryCode);
  const addressKeys = country
    ? country.addressPartDisplayNames
    : localeDataset.getDefaultAddressDisplayNames();
  const labelKey = addressKeys[addressPart];
  const label = labelKey ? t(labelKey) : '';
  return label;
}
